import React from 'react';
import {Banner} from '@shopify/polaris';
import {MaxWidthContainer} from './styled';

export default class AuthGatekeeper extends React.Component {
	state = {
		hmac: null,
		inputValue: ''
	};

	componentDidMount() {
		const params = new URLSearchParams(window.location.search);

		this.setState({
			hmac: params.get('hmac') || null
		});
	}

	render() {
		if (!this.state.hmac) {
			return (
				<MaxWidthContainer>
					<Banner
						status="critical"
						icon="alert"
					>
						<h1>
							This app must be installed through Shopify
						</h1>
					</Banner>
				</MaxWidthContainer>
			)
		}

		return this.props.children;
	}
}


// WEBPACK FOOTER //
// ./src/components/auth-gatekeeper.js